"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenderSchema = void 0;
const zod_1 = require("zod");
const gender_1 = require("../types/gender");
exports.GenderSchema = zod_1.z.union(Object.values(gender_1.Gender).map(gender => zod_1.z.literal(gender)));
//# sourceMappingURL=gender.js.map